import { FC, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface IProps {
  title: string;
  type?: string;
  description?: string;
  imageUrl?: string;
  pageUrl?: string;
  keyword?: string;
}

const SEO: FC<IProps> = ({ title, type = 'website', description, imageUrl, pageUrl, keyword }) => {
  const { t } = useTranslation();
  const seoTitle = useMemo(() => `${t('seo.main_title')} | ${title}`, [title]);
  const seoPathUrl = useMemo(() => window.location.href, []);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name='title' content={seoTitle} />
      {description ? <meta name='description' content={description} /> : <></>}
      {keyword ? <meta name='keywords' content={keyword} /> : <></>}
      {imageUrl ? <link rel='apple-touch-icon' href={imageUrl} /> : <>/</>}

      {/* Open Graph / Facebook */}
      <meta property='og:title' content={seoTitle} />
      <meta property='og:type' content={type} />
      {seoPathUrl ? <meta property='og:url' content={seoPathUrl} /> : <></>}
      {description ? <meta property='og:description' content={description} /> : <></>}
      {imageUrl ? (
        <>
          <meta property='og:image' content={imageUrl} />
          <meta property='og:image:secure_url' content={imageUrl} />
        </>
      ) : (
        <></>
      )}

      {/* Twitter */}
      <meta property='twitter:title' content={seoTitle} />
      <meta property='twitter:card' content='summary_large_image' />
      {seoPathUrl ? <meta property='twitter:url' content={seoPathUrl} /> : <></>}
      {description ? <meta property='twitter:description' content={description} /> : <></>}
      {imageUrl ? <meta property='twitter:image' content={imageUrl} /> : <></>}
      {/* End standard metadata tags */}
    </Helmet>
  );
};

export default SEO;
